<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/working.png" /></div>
      <p>工作台</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/working/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "皮肤",
          linkList: [ur + "working-skin.css", ur + "menu-bg.png"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListWorking.vue